import "./IvSidebarComponent.scss";
import {IOnDestroy, IOnInit} from "angular";
import {IvSidebarService} from "./service/IvSidebarService";
import {UserConfig} from "../../../types/UserConfig";
import {WatchListStore} from "../../../watchlist/store/WatchListStore";
import {ReplaySubject} from "rxjs";
import {WatchlistId} from "../../../watchlist/models/WatchlistId";
import {isNotNull} from "../../../js/util/UtilFunctions";
import {LocalStorageService} from "../../../types/NgStorage";

export const IvSidebarComponent = "ivSidebar";

export function ivSidebarComponent() {
    return {
        templateUrl: "app/components/ui/iv-sidebar/IvSidebarComponent.html",
        controllerAs: "ctrl",
        controller: IvSidebarComponentController
    };
}

const PreviousWatchlistStorageKey = "sidebarSelectedWatchlist";

export class IvSidebarComponentController implements IOnInit, IOnDestroy {

    public isOpen = true;
    public readonly selected$ = new ReplaySubject<WatchlistId | null>(1);

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly ivSidebarService: IvSidebarService,
                       public readonly userConfig: UserConfig,
                       private readonly watchListStore: WatchListStore,
                       private readonly $localStorage: LocalStorageService) {
    }

    public $onInit(): void {
        this.ivSidebarService
            .onStateChange()
            .takeUntil(this.destroyed$)
            .subscribe(isOpen => this.isOpen = isOpen);

        const previouslySelected = this.$localStorage[PreviousWatchlistStorageKey];
        if (previouslySelected != null) {
            this.selected$.next(previouslySelected);
        }

        this.watchListStore
            .defaultWatchlist
            .filter(isNotNull)
            .first()
            .takeUntil(this.selected$) // If we get another selection then stop trying to get a default
            .map((wl) => wl.id)
            .subscribe((id) => this.selected$.next(id));
    }

    public toggle() {
        const newState = !this.isOpen;
        this.ivSidebarService.stateChanged(newState);
    }

    public watchlistSelectionChanged(id: WatchlistId) {
        this.selected$.next(id);
        this.$localStorage[PreviousWatchlistStorageKey] = id;
    }

    public $onDestroy(): void {
        this.ivSidebarService.stateChanged(false);
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
